import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, LockIcon, RotateCcwIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { CountdownTimer } from './CountdownTimer';
import { CHECKOUT_URL } from '../utils/checkout';
import { trackAddToCart } from '../utils/metaPixel';
const badges = [{
  icon: ShieldCheckIcon,
  label: 'SSL Seguro'
}, {
  icon: CheckIcon,
  label: 'Pago Único'
}, {
  icon: RotateCcwIcon,
  label: 'Garantía 07 días'
}, {
  icon: ZapIcon,
  label: 'Acceso Inmediato'
}];
export function FinalCta() {
  return <section id="final" className="w-full scroll-mt-16 py-20" style={{
    background: 'linear-gradient(135deg, #1A3C2E 0%, #0D2419 100%)'
  }} data-id="element-72" data-mp="1t2yaujjn275h">
      <div className="mx-auto max-w-[600px] px-5 text-center sm:px-6" data-id="element-73" data-mp="1o568swpa54nk">
        <Reveal data-id="element-74" data-mp="22336jwfgzh3t">
          <span className="inline-flex items-center gap-1.5 rounded-full border border-gold px-4 py-1 text-[12px] font-semibold text-gold" data-id="element-75" data-mp="224o3fsp9bc4u">
            <ZapIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-76" data-mp="1x2gpixkv9lzv" />
            Oferta de Lanzamiento
          </span>

          <h2 className="mt-5 text-[28px] font-bold leading-[1.08] tracking-tight text-white sm:text-[42px]" data-id="element-77" data-mp="s4pefvii8qe2">
            Tu Cuerpo Lleva Años Esperando Esta Decisión.
          </h2>

          <p className="mt-3 text-lg italic text-gold sm:text-xl" data-id="element-78" data-mp="x64z3mgrsuvx">Hoy cuesta menos que un café.</p>
        </Reveal>

        <Reveal delay={0.06} className="mt-7 flex justify-center" data-id="element-79" data-mp="164goxm9tbonb">
          <CountdownTimer size="lg" data-id="element-80" data-mp="1646wzt57j7ez" />
        </Reveal>

        <Reveal delay={0.1} data-id="element-81" data-mp="1b2rtpil938yo">
          <p className="mt-5 text-[15px] text-white/85" data-id="element-82" data-mp="1b1yy9drqs5vu">
            Producto principal + 3 Bonos Gratis — Valor $238 — Solo $9.99
          </p>

          <div className="relative mx-auto mt-7 w-full max-w-lg" data-id="element-83" data-mp="1kt3cgb9lfmpm">
            <motion.span aria-hidden="true" className="pointer-events-none absolute inset-0 rounded-2xl ring-2 ring-gold" animate={{
            scale: [1, 1.06],
            opacity: [0.55, 0]
          }} transition={{
            duration: 1.8,
            repeat: Infinity,
            ease: 'easeOut'
          }} data-id="element-84" data-mp="1kvfqweg57exx" />
            <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="relative flex min-h-14 w-full items-center justify-center rounded-2xl bg-coral px-6 py-4 text-center text-base font-bold leading-tight text-white shadow-2xl transition-transform duration-150 ease-out hover:scale-[1.02] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold sm:text-lg" data-id="element-85" data-mp="3lvkoe503qxz2">
              SÍ — DESCARGO AHORA POR $9.99 USD →
            </a>
          </div>

          <p className="mt-3 flex items-center justify-center gap-1.5 text-xs text-white/75" data-id="element-86" data-mp="mgqsie4cbdzu">
            <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-87" data-mp="ielznhlpule9" />
            Pago seguro · Descarga instantánea · Sin suscripciones
          </p>

          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-8 gap-y-3" data-id="element-88" data-mp="2o83rkmjmmrnz">
            {badges.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center gap-1.5 text-[12px] font-medium text-white/70" data-id="element-89" data-mp="2a3d0a0zl5rxx">
                <Icon className="h-4 w-4" aria-hidden="true" data-id="element-90" data-mp="2e2lsv2iw3jrw" />
                {label}
              </li>)}
          </ul>
        </Reveal>
      </div>
    </section>;
}